export default {"src":"__ASTRO_ASSET_IMAGE__BkZU4DuZ__","width":672,"height":1255,"format":"png"}